import React from "react";
import { Button } from "../../components/ui/button";
import { Download as DownloadIcon } from "lucide-react";
import { showFreeAssessmentToast } from "../../utils/freeAssessmentRedirect";

const DownloadReport = ({ buttonClassName = "w-auto" }) => {
  const handleDownloadDashboardPdf = () => {
    // Show toast for USP feature
    showFreeAssessmentToast();
  };

  return (
    <div className="flex justify-end">
      <Button
        onClick={handleDownloadDashboardPdf}
        className={`bg-[#3B0F82] hover:bg-[#2d0b66] text-white ${buttonClassName}`}
      >
        <DownloadIcon className="w-4 h-4 mr-2" />
        Download PDF
      </Button>
    </div>
  );
};

export default DownloadReport; 